import { Authorize, GlobalButton, NavigateLinks } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { useEffect, useMemo, useState } from 'react';
import {
  Add as AddIcon,
  UploadFile as UploadFileIcon,
  MarkEmailRead as MarkEmailReadIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { ShippingsTable, SearchBar } from './components';
import { childrenBusinessPageBreadcrumbs } from '../../config';
import useShippingsFilter from './hooks/useShippingsFilter';
import useShippingsPagination from './hooks/useShippingsPagination';
import { useShippings } from './hooks';
import { COUNTRY } from '@/config/country';

export const Shippings = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const { filter, initialFilter, setFilter } = useShippingsFilter();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } = useShippingsPagination();
  const [searchRequestId, setSearchRequestId] = useState(0);

  const {
    shippings,
    totalItems,
    totalPages,
    isShippingsLoading,
    isShippingsFetching,
    refetchShippings,
  } = useShippings({ 
    page: currentPage, 
    pageSize, 
    filters: filter 
  });

  useEffect(() => {
    if (searchRequestId === 0) return;
    void refetchShippings();
  }, [searchRequestId, refetchShippings]);

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <div className='flex flex-col'>
        <NavigateLinks actualPage='Envíos' breadcrumbs={breadcrumbs} />
        <Authorize permission={BUSINESS_ROLE_GROUPS.operations}>
          <div className='flex justify-end gap-2'>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={() => navigate('import')}
            >
              <UploadFileIcon />
              Importar pedidos
            </GlobalButton>
            {/* El Correo Uruguayo solo opera en Uruguay: en el panel de Perú
                el import no tendría contra qué buscar los pedidos. */}
            {COUNTRY === 'uy' && (
              <GlobalButton
                variant={GlobalButtonVariant.secondaryButton}
                action={() => navigate('correo-deliveries-import')}
              >
                <MarkEmailReadIcon />
                Entregas del Correo
              </GlobalButton>
            )}
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={() => navigate('create')}
            >
              <AddIcon />
              Nuevo Envío
            </GlobalButton>
          </div>
        </Authorize>
      </div>
      <SearchBar
        initialFilter={initialFilter}
        filter={filter}
        isLoading={isShippingsFetching}
        search={(updatedFilter) => {
          setFilter(updatedFilter);
          handlePageChange(1);
          setSearchRequestId((id) => id + 1);
        }}
      />
      <ShippingsTable 
        shippings={shippings}
        isLoading={isShippingsLoading}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        logisticOperatorId={filter.logisticOperatorId}
      />
    </section>
  );
};

export default Shippings;
